module.exports = __webpack_public_path__ + "static/media/DC_O_Jacquard_Vela_DK Grey_LT Grey.5eaa7893.png";